import React, { memo } from 'react';
import { Popover, ButtonGroup, Button, Tooltip } from '@mui/material';
import { withStyles } from 'tss-react/mui';

const styles = (theme) => ({
    buttonGroup: {
        backgroundColor: theme.palette.background.paper,
        boxShadow: theme.shadows[2],
        borderRadius: theme.shape.borderRadius,
    },
    actionButton: {
        padding: theme.spacing(1),
        minWidth: 'auto',
        color: theme.palette.text.secondary
    },
    popover: {
        lineHeight: 0,
    }
});

const ActionButton = memo(({ label, icon, onClick, className }) => (
    <Tooltip title={onClick ? label : ''} placement='top' arrow>
        <Button
            onClick={onClick}
            disabled={!onClick}
            aria-label={label}
            className={className}
        >
            {icon}
        </Button>
    </Tooltip>
));

const WaveLayerActions = memo(({ classes, actions, anchorEl, onClose }) => {
    return (
        <Popover
            anchorEl={anchorEl}
            keepMounted
            open={Boolean(anchorEl)}
            onClose={onClose}
            anchorOrigin={{
                vertical: 'bottom',
                horizontal: 'center',
            }}
            transformOrigin={{
                vertical: 'top',
                horizontal: 'center',
            }}
            className={classes.popover}
        >
            <ButtonGroup
                size='small'
                aria-label='Wave layer action button group'
                variant='text'
                className={classes.buttonGroup}
            >
                {actions.map(action => (
                    <ActionButton
                        key={action.label}
                        {...action}
                        className={classes.actionButton}
                    />
                ))}
            </ButtonGroup>
        </Popover>
    );
});

export default withStyles(WaveLayerActions, styles);
